/**
 * @author Ariel
 * @description 查看记录
 * @Date 2020/02/21
 */
import React from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'dva'
import { modelUtils } from '../../../../utils'
import '../../../../styles/containers/online/examRecordDetail/index.less'
import { component_tool, framework_tool, utils_tool } from '@/tool';
import { ExamPercent } from '../../../../components'
let { Storage } = utils_tool
let {
  WizModal,
  WizSpin,
  WizCard,
  WizRow,
  WizCol,
  WizCollapse,
  WizButton,
  WizSearchBar,
  WizDataTable,
  WizBrowserExport,
  WizTypography
} = component_tool
let { WizContainer } = framework_tool
let { Session, getPageData, excelUtils } = utils_tool
let { Text } = WizTypography
import createColumns from './columns'

/**获取上一页数据作为本页参数*/
const getParamRecord = (history) => {
  let record = {}

  if (history.location && history.location.pathname === '/online/examRecord/examRecordInfo') {
    if (history.location && history.location.record) {
      record = history.location.record
      Session.set('examRecordInfo', record)
    } else {
      record = Session.get('examRecordInfo') || {};
    }
  }
  return record
}

const _getValue = (type, key) => {
  const values = {
    pass: {
      0: '未通过',
      1: '通过',
      2: '批阅中'
    },faceStatus: {
      0: '无需身份验证审核',
      1: '身份验证审核通过',
      2: '身份验证待审核',
      3: '身份验证未通过'
    },
  }
  return values[type][key]
}

class ExamRecordInfo extends WizContainer {
  componentName = 'ExamRecordInfo';

  constructor(props) {
    super(props);
    let use = Storage.getStorage('user') || {}
    //是否禁用编辑权限
    this.flag = false
    if (use && use.personId === '1cdf270fdc764dfb91634d3b2f48257f') {
      this.flag = true;
    }
    const { history } = this.props;
    this._record = getParamRecord(history)
    this.filters = {}
    this.state = {
      modelKey: '',
      record: null,
      visible: false,
      selectedRows: 0,
      keys: [],
      rows: [],
    }
  }

  propsAndStateOnChange = {
    infoExport: this._infoExportOver.bind(this),
    infoCharts: this._infoChartsOver.bind(this),
    fullMarkPaper: this._refreshOver.bind(this, 'fullMarkPaper'),
    delPaper: this._refreshOver.bind(this, 'delPaper'),
    exportByStudentAnswerDetail: this._exportByStudentAnswerDetailOver.bind(this)
  }

  _exportByStudentAnswerDetailOver(nextProps, nextState, key) {
    let response = nextProps.exportByStudentAnswerDetail
    const blob =response['result'];
    let link = document.createElement('a');
    let body = document.querySelector('body');

    link.href = window.URL.createObjectURL(blob);
    link.download = '学员答题情况.xls';

    // fix Firefox
    link.style.display = 'none';
    body.appendChild(link);

    link.click();
    body.removeChild(link);
  }

  _refreshOver(key, nextProps, nextState) {
    if(!key) {
      wizNotice.error('错误的key')
      return false;
    }
    let {code, success, msg} = nextProps?.[key] || {}

    if (code === 1) {
      this._selectExamRecordInfo(7)
      this._getChartData()
      return true;
    } else {
      wizNotice.error(msg || '系统运行繁忙')
      return false;
  }
}
  /**导出数据*/
  _infoExportOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '手机号',
        field: 'mobile',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '身份证号/工号',
        field: 'idCard',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '成绩',
        field: 'score',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '通过状态',
        field: 'passName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '用户属性',
        field: 'userTypeName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '账号状态',
        field: 'accountStatus',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '区域',
        field: 'areaName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织名称',
        field: 'orgName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '岗位',
        field: 'positionName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '任职状态',
        field: 'jobStateName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '考试开始时间',
        field: 'startDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '考试结束时间',
        field: 'endDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }
    ]
    if (nextProps.infoExport.code === 1) {
      let data = nextProps.infoExport.data
      data && data.forEach(e => {
        if (e['pass'] === 2) {
          e['score'] = null
        }
        let faceStatus = e['faceStatus'];
        if (faceStatus ===null || faceStatus===undefined || (faceStatus===0 || faceStatus===1)){
          e['passName'] = _getValue('pass', e['pass'])
        }else {
          e['passName'] = _getValue('faceStatus', e['faceStatus'])
        }
      })
      WizBrowserExport({
        title: '考试记录信息',
        sheetName: '考试记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '考试记录信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }

  _componentDidMount = () => {
    this._selectExamRecordInfo(7)
    this._getChartData()
  }

  /**图表数据获取情况*/
  _infoChartsOver(nextProps, nextState) {
    let data = []
    if (nextProps.infoCharts.code === 1) {
      data = nextProps.infoCharts.data
      this.chartsData = data
      return true;
    } else {
      wizNotice.error('图表数据获取失败！！')
      return false;
    }
  }

  /**获取图表数据*/
  _getChartData() {
    let apiPath = "examRecord/infoCharts";
    this.doAction({
      path: apiPath,
      payload: {
        key: 'examRecord@infoCharts',
        apiParams: { examId: this._record.id }
      }
    })
  }

  /**导出接口*/
  _selectExportInfo(apiParams = {}) {
    let apiPath = "examRecord/infoExport";
    this.doAction({
      path: apiPath,
      payload: {
        key: 'examRecord@infoExport',
        apiParams: { examId: this._record.id, ...apiParams }
      }
    })
  }
  _fullMarkPaper(apiParams = {}) {
    if(this.state.keys&& this.state.keys.length==0){
      wizNotice.error('请至少选择一项')
    }
    let apiPath = "examPaper/fullMarkPaper";
    this.doAction({
      path: apiPath,
      payload: {
        key: 'examPaper@fullMarkPaper',
        apiParams: {  paperIds:this.state.keys }
      }
    })
  }

  _delPaper(apiParams = {}) {
    if(!this.state?.keys?.length){
      wizNotice.error('请至少选择一项')
      return;
    }

    WizModal.confirm({
      title: '注意',
      content: "是否确认删除试卷,删除后无法恢复,请谨慎操作!",
      cancelText: "取消",
      okText: "确认删除",
      okButtonProps: {
        type: 'danger',
        icon: 'delete'
      },
      onOk: () => {
        this.doAction({
          path: "examPaper/delPaper",
          payload: {
            key: 'examPaper@delPaper',
            apiParams: { paperIds: this.state.keys }
          }
        })
      },
      onCancel: () => {}
    });
  }

  /**
   * 获取列表数据方法
   */
  _selectExamRecordInfo(apiParams = {}) {
    let apiPath = "examRecord/infoPageList";
    this.doAction({
      path: apiPath,
      payload: {
        key: "examRecordInfo" + '@' + this._record.id,
        apiParams: {  examId: this._record.id, ...apiParams, orgId: Array.isArray(apiParams.orgId) ? null : apiParams.orgId, posId: Array.isArray(apiParams.posId) ? null : apiParams.posId }
      }
    })
  }

  /**跳转查看任职*/
  _onLookPosition(record) {
    this.jumpPage('push', '/online/examRecord/examRecordInfo/lookPositionInfo', { ...record, showAuthority: false });
  }

  /**导出答卷*/
  _onLookExamPaper(record) {
    console.log("record==",record)
    this.doAction({
      path: 'examRecord/exportByStudentAnswerDetail',
      payload: {
        key: 'examRecord@exportByStudentAnswerDetail',
        apiParams: {
          examId: this._record.id,
          personId:record.personId
        }
      }
    })
  }

  _onSelect(keys, rows) {
    this.setState({
        keys,
        rows,
        selectedRows: keys.length
    })
  }

  _renderSearchTable(title) {
    let type = "ExamRecordInfoByExamId"
    let { record, visible, selectedRows, rows } = this.state

    let dataItems = getPageData(this.props[type] && this.props[type].data)

    let columns = createColumns(this)
    let searchBarProps = {
      columns,
      onSearch: values => {
        this.filters = values;
        this._selectExamRecordInfo(values)
        this._onSelect([], [])
      }
    }
    let dataTableProps = {
      columns,
      rowKey: 'id',
      selectType: 'checkbox',
      dataItems,
      showNum: false,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this._selectExamRecordInfo( { current: pageNum, size: pageSize, ...this.filters })
      },
      selectedRowKeys: rows.map(item => item.rowKey),
      onSelect: (keys, rows) => this._onSelect(keys, rows)
    }
    return (
      <>
          <WizSearchBar key={'examRecordInfo' + '_searchBar'} type='grid' {...searchBarProps} />
          <WizButton.WizGroup>
            <WizButton
              title="导出"
              type="primary"
              onClick={() => this._selectExportInfo(this.filters)}
              icon="export"
            >
              导出
            </WizButton>
            {this.flag?<WizButton
              title="学员满分"
              type="primary"
              onClick={() => this._fullMarkPaper(this.filters)}
              icon="sync"
            >
              学员满分
            </WizButton>:null}
            {this.flag ? <WizButton title="删除试卷" type="danger" onClick={() => this._delPaper(this.filters)} icon="delete">删除试卷</WizButton> : null}

          </WizButton.WizGroup>
          <WizDataTable key={'examRecordInfo' + '_dataTable'} {...dataTableProps} />
          <div className='pagination'>
            <WizDataTable.Pagination key={'examRecordInfo' + '_pagination'} {...dataTableProps} />
          </div>
      </>

    )
  }

  _render() {
    let londing = this.props.examRecordLoading || this.props.examPaperLoading
    let examPrecent = this.chartsData ? <ExamPercent
      headerProps={{ title: '考试名称', value: this._record.title }}
      percentProps={{
        data: [
          {
            item: "通过人次",
            count: this.chartsData.examPassNumCount,
          },
          {
            item: "未通过人次",
            count: this.chartsData.examPassNotNumCount,
          }
        ],
        dataFormat: {
          type: "percent",
          field: "count",
          dimension: "item",
          as: "percent"
        },
        count: this.chartsData.examNumCount,
        centerText: '考试人次'
      }}
      itemProps={[
        { img: constants.files.sys_exam_precent_max, title: '最高次数', value: this.chartsData.examMaxCount + '次' },
        { img: constants.files.sys_exam_precent_avg, title: '平均次数', value: this.chartsData.examAvgCount + '次' },
        { img: constants.files.sys_exam_precent_min, title: '最低次数', value: this.chartsData.examMinCount + '次' }
      ]}
      footerView={(
        <Text>考试人数：{this.chartsData.examNum ? this.chartsData.examNum : 0}人，在考人数：{this.chartsData.onExamNum ? this.chartsData.onExamNum : 0}人</Text>
      )}
    /> : null
    return (
      <>
        <WizSpin tip={"加载中"} spinning={londing}>
          <WizCard title={'记录概况'}>
            {examPrecent}
          </WizCard>
          <WizCard title={'记录信息'}>
              {this._renderSearchTable('记录信息', '记录信息')}
          </WizCard>
        </WizSpin>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { examRecord,examPaper } = state;
  const { history } = ownProps
  let record = getParamRecord(history)
  const infoExport = modelUtils.getModelEntity(examRecord, 'examRecord@infoExport')
  const infoCharts = modelUtils.getModelEntity(examRecord, 'examRecord@infoCharts')
  const fullMarkPaper = modelUtils.getModelEntity(examPaper, 'examPaper@fullMarkPaper')
  const delPaper = modelUtils.getModelEntity(examPaper, 'examPaper@delPaper')

  const ExamRecordInfoByExamId = modelUtils.getModelEntity(examRecord, 'examRecordInfo@' + record.id);
  
  const exportByStudentAnswerDetail = modelUtils.getModelEntity(examRecord, 'examRecord@exportByStudentAnswerDetail')
  
  const load = modelUtils.getLoadingState(state,  ['examRecord','examPaper']);
  return {
    infoExport,
    infoCharts,
    fullMarkPaper,
    delPaper,
    ExamRecordInfoByExamId,
    exportByStudentAnswerDetail,
    ...load
  }

};

export default connect(mapStateToProps)(ExamRecordInfo);
